import React from "react";
import "./Results.css";

function Results({ words }) {
	console.log(words);
	if (words.length === 0) {
		return <div className="results">No words found</div>;
	} else {
		let items = words.map((item, index) => (
			<span className="word" key={index}>
				{item}
			</span>
		));
		return <div className="results">{items}</div>;
	}
}

export default React.memo(Results);
